import { ChildExecutorDecisionTypeId as ChildExecutorDecisionTypeId$1, Continue as Continue$1, Close as Close$1, Yield as Yield$1, isChildExecutorDecision as isChildExecutorDecision$1, isContinue as isContinue$1, isClose as isClose$1, isYield as isYield$1, match as match$1 } from '../../internal/channel/childExecutorDecision.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const ChildExecutorDecisionTypeId = ChildExecutorDecisionTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Continue executing the current substream
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Close the current substream with a given value and pass execution to the
 * next substream
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Pass execution to the next substream. This either pulls a new element
 * from upstream, or yields to an already created active substream.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const Continue = Continue$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const Close = Close$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const Yield = Yield$1;

/**
 * Returns `true` if the specified value is a `ChildExecutorDecision`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isChildExecutorDecision = isChildExecutorDecision$1;

/**
 * Returns `true` if the specified `ChildExecutorDecision` is a `Continue`,
 * `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isContinue = isContinue$1;

/**
 * Returns `true` if the specified `ChildExecutorDecision` is a `Close`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isClose = isClose$1;

/**
 * Returns `true` if the specified `ChildExecutorDecision` is a `Yield`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isYield = isYield$1;

/**
 * Folds over a `ChildExecutorDecision` to produce a value of type `A`.
 *
 * @since 2.0.0
 * @category folding
 */
const match = match$1;

export { ChildExecutorDecisionTypeId, Close, Continue, Yield, isChildExecutorDecision, isClose, isContinue, isYield, match };
